<template>
  <fieldset ref="streetFieldset" :class="[
    `${name}-group`,
    {'mandatory': mandatory},
     !disabled ? vflowGetFeedbackClasses('inputModel') : '',
     width !== '' ? 'width' + width : '']"
    >
    <label
      @mousedown="isLabelClicked = true"
      @blur="isLabelClicked = false"
      :for="name">
      <slot name="lbl">{{ name }} (Default-Text)</slot>
    </label>
    <slot name="txtAfterLabel"></slot>
    <b-form-input
      @mousedown="isClicked = true"
      @blur="vflowInputBlurred('inputModel'); isClicked = false; isFocusedWithoutClick = false; isNavigatingInProviders = false; isUserTyping = false"
      @focus="vflowInputFocused('inputModel'); onFocus()"
      @input="itemSelected = false; focusedItemText = ''; ariaExpanded = !!inputModel; $v['inputModel'].$touch();"
      @keyup="onArrowKeyScroll"
      :formatter="formatter"
      :name="name"
      :id="name"
      :required="mandatory"
      :type="type === 'password' ? passwordType : type"
      :aria-required="mandatory"
      :aria-invalid="$v.inputModel.$invalid"
      :aria-describedby="hasErrorClasses && $v.inputModel.$invalid ? 'errmsg-' +name : ''"
      v-model="inputModel"
      :placeholder="slottedPlaceholder"
      :disabled="disabled"
      :class="['form-control', isFocusedWithoutClick ? 'is-focus-visible' : '']"
      aria-haspopup="listbox"
      aria-autocomplete="both"
      :aria-live="ariaLiveForInput"
      :aria-label="ariaLabelForInput"
      :aria-expanded="ariaExpanded"
      aria-controls="autocompletePacListId"
      role="combobox"
    >
    </b-form-input>
    <b-form-invalid-feedback :id="'errmsg-' +name" role="alert">
      <slot name="txtInvalidLength" v-if="$v.inputModel.maxLength === false || $v.inputModel.minLength === false">
        Diese Eingabe hat nicht die richtige Länge.
      </slot>
      <slot name="txtRequiredLength" v-else-if="$v.inputModel.required === false">
        Dies ist ein Pflichtfeld.
      </slot>
      <slot name="txtInvalid" v-else-if="$v.inputModel.$invalid">
        Diese Eingabe ist ungültig.
      </slot>
    </b-form-invalid-feedback>
  </fieldset>
</template>
<script>

import syncProperty from '@/mixins/syncProperty'
import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'
import required from 'vuelidate/lib/validators/required'
import googleAutocomplete from '@/mixins/googleAutocomplete'

export default {
  name: 'LabeledStreetInput',
  data () {
    return {
      inputModel: this.model,
      showInfoModal: false,
      isFocusedWithoutClick: false,
      isClicked: false,
      isLabelClicked: false,
      focusedItemText: '',
      focusedItemIndex: -1,
      itemListLength: null,
      itemSelected: false,
      inputValue: '',
      isUserTyping: false,
      isNavigatingInProviders: false,
      ariaExpanded: false,
      hasErrorClasses: false
    }
  },
  mixins: [
    validationMixin,
    validationFlow,
    googleAutocomplete(),
    syncProperty('model', 'model_')
  ],
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    },
    inputModel: {
      immediate: true,
      handler: function (newValue) {
        this.model_ = newValue
      }
    },
    model: {
      immediate: true,
      handler: function (newValue) {
        if (this.inputModel !== newValue) {
          this.inputModel = newValue
        }
      }
    }
  },
  methods: {
    onFocus () {
      if (!this.isClicked && !this.isLabelClicked) {
        this.isFocusedWithoutClick = true
      }

      this.isLabelClicked = false
      this.focusedItemText = ''
      this.itemSelected = false
    },
    onArrowKeyScroll (event) {
      const focusedItem = document.querySelector('.pac-item-selected')

      switch (event.keyCode) {
        case 33:
        case 38:
        case 34:
        case 40:
          this.isNavigatingInProviders = true
          this.$nextTick(() => {
            if (focusedItem) {
              const itemList = document.querySelectorAll('.pac-item')
              this.$set(this, 'focusedItemText', this.pacItemParser(focusedItem))
              this.$set(this, 'focusedItemIndex', itemList && focusedItem ? Array.from(itemList).indexOf(focusedItem) : -1)
            } else {
              this.$set(this, 'focusedItemText', '')
            }
          })
          break
        default:
      }
    },
    pacItemParser (focusedItem) {
      return focusedItem ? `${focusedItem.querySelector('.pac-item-query')?.innerHTML.replace(/<[^>]*>/g, '')} ${focusedItem.lastElementChild?.innerHTML.replace(/<[^>]*>/g, ' ')}` : ''
    },
    onPacContainerClicked (event) {
      this.$set(this, 'focusedItemText', this.pacItemParser(event.target.closest('.pac-item')))
    },
    autocompleteCallback () {
      this.setupAutocompleteHandler(document.getElementById('street'), document.getElementById('main'))
    },
    autocompleteHasNewResults () {
      const itemList = document.querySelectorAll('.pac-item')
      if (itemList && itemList.length) {
        this.itemListLength = itemList.length
        this.ariaExpanded = true
      } else {
        this.ariaExpanded = false
      }
    },
    performAutocomplete () {
      this.itemSelected = true
      this.performAutocompleteForm(this.autocompleteHandler.getPlace())
    },
    observeClassChange () {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            this.hasErrorClasses = !!this.vflowGetFeedbackClasses('inputModel')['required-failed'] && !!this.vflowGetFeedbackClasses('inputModel')['show-feedback']
          }
        })
      })

      observer.observe(this.$refs.streetFieldset, { attributes: true, attributeFilter: ['class'] })
    }
  },
  computed: {
    slotAltTagLabelIcon: function () {
      const altTag = 'Weitere Informationen zum Eingabefeld ' + this.getSlotText('lbl', this.name)
      return this.getSlotText('txtInfoIconAlt', altTag)
    },
    captializedName: function () {
      return this.name.charAt(0).toUpperCase() + this.name.slice(1)
    },
    slottedPlaceholder: function () {
      return this.$slots.txtPlaceholder?.[0]?.text || this.placeholder
    },
    mountInfoModal: function () {
      return this.$slots.txtInfoModal
    },
    ariaLiveForInput () {
      if (this.isNavigatingInProviders) {
        return 'polite'
      } else if (this.isUserTyping) {
        return 'polite'
      } else { return 'off' }
    },
    ariaLabelForInput () {
      if (this.itemSelected) {
        return this.focusedItemText + ' selektiert.'
      } else if (this.focusedItemText) {
        return `Element ${this.focusedItemIndex + 1} von ${this.itemListLength}`
      } else { return this.inputAriaLabel }
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    validation: {
      type: Object
    },
    formatter: {
      type: Function,
      default: (a) => a
    },
    width: {
      type: String,
      default: '',
      validator: function (value) {
        return ['25', '33', '66', '75', ''].includes(value)
      }
    },
    labelAriaLabel: {
      type: String,
      default: null
    },
    inputAriaLabel: {
      type: String,
      default: null
    },
    performAutocompleteForm: {
      type: Function,
      default: () => {}
    }
  },
  mounted () {
    this.initiateAutocomplete(this.autocompleteCallback, 'autocompletePacListId')
    this.hasErrorClasses = !!this.vflowGetFeedbackClasses('inputModel')['required-failed'] && !!this.vflowGetFeedbackClasses('inputModel')['show-feedback']
    this.observeClassChange()
  },
  validations () {
    if (this.validation) {
      return {
        inputModel: this.validation
      }
    }
    return {
      inputModel: {
        ...(this.mandatory ? { required } : {})
      }
    }
  }
}
</script>
